// import { useLocation } from "react-router-dom";
// import { serviceSlugLookup } from "@/config/servicesMenu";
// import woodBg from "../../assets/wood.png"; // ← update path to match your actual asset location

// const pageNameMap = {
//   "/": "Home",
//   "/about": "About Us",
//   "/services": "Services",
//   "/gallery": "Gallery",
//   "/case-studies": "Case Studies",
//   "/published-papers": "Published Papers",
//   "/blogs": "Blogs",
//   "/contact": "Contact",
//   "/safety-measures": "Safety Measures",
//   "/technology": "Technology",
//   "/highlights": "Highlights",
//   "/our-team": "Our Team",
//   "/dentistry/aesthetic": "Aesthetic Dentistry",
//   "/dentistry/implant": "Implant Dentistry",
// };

// export default function PageNameBar() {
//   const { pathname } = useLocation();
//   let pageName = pageNameMap[pathname] || "Kavlekar Dental";

//   if (pathname.startsWith("/services/")) {
//     const slug = pathname.replace("/services/", "");
//     pageName = serviceSlugLookup[slug]?.title || "Service Details";
//   } else if (pathname.startsWith("/blogs/")) {
//     pageName = "Blog Details";
//   } else if (pathname.startsWith("/case-studies/")) {
//     pageName = "Case Study Details";
//   }

//   return (
//     <div
//       className="w-full py-1.5 text-center"
//       style={{
//         backgroundImage: `url(${woodBg})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         backgroundRepeat: "no-repeat",
//       }}
//       data-testid="page-name-golden-bar"
//     >
//       <p
//         className="font-[Manrope] text-xs font-semibold uppercase tracking-[0.18em] text-white md:text-sm drop-shadow-[0_1px_2px_rgba(0,0,0,0.6)]"
//         data-testid="page-name-golden-bar-title"
//       >
//         {pageName}
//       </p>
//     </div>
//   );
// }

import { useLocation } from "react-router-dom";
import { serviceSlugLookup } from "@/config/servicesMenu";

const pageNameMap = {
  "/": "Home",
  "/about": "About Us",
  "/services": "Services",
  "/gallery": "Gallery",
  "/case-studies": "Case Studies",
  "/published-papers": "Published Papers",
  "/blogs": "Blogs",
  "/contact": "Contact",
  "/safety-measures": "Safety Measures",
  "/technology": "Technology",
  "/highlights": "Highlights",
  "/our-team": "Our Team",
  "/dentistry/aesthetic": "Aesthetic Dentistry",
  "/dentistry/implant": "Implant Dentistry",
};

export default function PageNameBar() {
  const { pathname } = useLocation();
  let pageName = pageNameMap[pathname] || "Kavlekar Dental";

  if (pathname.startsWith("/services/")) {
    const slug = pathname.replace("/services/", "");
    pageName = serviceSlugLookup[slug]?.title || "Service Details";
  } else if (pathname.startsWith("/blogs/")) {
    pageName = "Blog Details";
  } else if (pathname.startsWith("/case-studies/")) {
    pageName = "Case Study Details";
  }

  return (
    <div
      className="w-full py-1.5 text-center"
      style={{
        background: "linear-gradient(#b8860b 0%)",
      }}
      data-testid="page-name-golden-bar"
    >
      <p
        className="font-[Manrope] text-xs font-semibold uppercase tracking-[0.18em] text-white md:text-sm drop-shadow-[0_1px_2px_rgba(0,0,0,0.6)]"
        data-testid="page-name-golden-bar-title"
      >
        {pageName}
      </p>
    </div>
  );
}